import { useQuery } from '@/hooks/useQuery';

export function useEntranceType() {
    /**
     * 入口来源，0-站内私信分享，1-站外分享，2-正常商品来源
     * 无缝拉活会丢失cc参数，增加fromShare参数，如果url里面没有cc且有fromShare，则表示来自无缝拉活
     */
    const cc = useQuery('cc');
    const fromShare = useQuery('fromShare');
    if (cc) {
        // 有cc且为私信
        if (cc === 'IM_CONVERSATION') {
            return 0;
        }
        // 有cc不为私信
        return 1;
    }
    // 无缝拉活没有cc，有fromShare
    if (fromShare) {
        return 1;
    }
    // 正常电商入口来源
    return 2;
}

export function useIsHalfWebView() {
    const webviewType = useQuery('webviewType');
    const isHalf = useQuery('isHalf');
    return webviewType === 'half' || +isHalf === 1;
}
